import { Box } from "@mui/material";
import {
	DateField,
	Show,
	SimpleShowLayout,
	TextField,
	useRecordContext,
} from "react-admin";

const StatusChip = () => {
	const record = useRecordContext();
	if (!record) return null;

	const colors: Record<string, string> = {
		queued: "#9e9e9e",
		processing: "#ff9800",
		transfer_created: "#2196f3",
		paid: "#4caf50",
		failed: "#f44336",
		reversed: "#9c27b0",
		needs_attention: "#e91e63",
	};

	return (
		<Box
			sx={{
				display: "inline-block",
				px: 1,
				py: 0.5,
				borderRadius: 1,
				backgroundColor: colors[record.status] || "#757575",
				color: "white",
				fontSize: "0.75rem",
				fontWeight: 500,
				textTransform: "uppercase",
			}}
		>
			{record.status.replace("_", " ")}
		</Box>
	);
};

const AmountField = () => {
	const record = useRecordContext();
	if (!record) return null;
	return <span>${(record.amountCentsUSD / 100).toFixed(2)} USD</span>;
};

export const PartnerPayoutShow = () => (
	<Show>
		<SimpleShowLayout>
			<TextField source="id" label="ID" />
			<StatusChip />
			<AmountField />
			<TextField source="partnerId" label="Partner ID" />
			<TextField source="appId" label="App ID" />
			<TextField source="appOwnerId" label="App Owner ID" />
			<TextField
				source="stripeTransferId"
				label="Stripe Transfer ID"
				emptyText="-"
			/>
			<TextField
				source="destinationStripeAccountId"
				label="Destination Account"
			/>
			<TextField source="sourceStripeAccountId" label="Source Account" />
			<TextField source="idempotencyHash" label="Idempotency Hash" />
			<DateField
				source="processingAt"
				label="Processing At"
				showTime
				emptyText="-"
			/>
			<TextField source="lastError" label="Last Error" emptyText="-" />
			<DateField source="createdAt" label="Created At" showTime />
			<DateField source="paidAt" label="Paid At" showTime emptyText="-" />
		</SimpleShowLayout>
	</Show>
);
